var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeenyiconsGiftSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "teenyicons:gift-solid",
    clipPath: "url(#clip0_1860_3742)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.3 0.5C2.81377 0.5 2.34745 0.693155 2.00364 1.03697C1.65982 1.38079 1.46667 1.8471 1.46667 2.33333V2.54307C1.46667 2.8716 1.5642 3.1774 1.73213 3.43333H1.1C0.808262 3.43333 0.528473 3.54923 0.322183 3.75552C0.115893 3.96181 0 4.2416 0 4.53333L0 5.26667C0 5.55841 0.115893 5.83819 0.322183 6.04448C0.528473 6.25077 0.808262 6.36667 1.1 6.36667H5.13333V3.43333H5.86667V6.36667H9.9C10.1917 6.36667 10.4715 6.25077 10.6778 6.04448C10.8841 5.83819 11 5.55841 11 5.26667V4.53333C11 4.2416 10.8841 3.96181 10.6778 3.75552C10.4715 3.54923 10.1917 3.43333 9.9 3.43333H9.26787C9.4358 3.1774 9.53333 2.8716 9.53333 2.54307V2.33333C9.53333 1.8471 9.34018 1.38079 8.99636 1.03697C8.65255 0.693155 8.18623 0.5 7.7 0.5C6.76647 0.5 5.9488 0.998667 5.5 1.74373C5.27185 1.36415 4.94932 1.0501 4.56379 0.832143C4.17826 0.614191 3.74287 0.499764 3.3 0.5ZM5.86667 3.43333H7.90973C8.40107 3.43333 8.8 3.0344 8.8 2.54307V2.33333C8.8 2.0416 8.68411 1.76181 8.47782 1.55552C8.27153 1.34923 7.99174 1.23333 7.7 1.23333C7.21377 1.23333 6.74745 1.42649 6.40364 1.7703C6.05982 2.11412 5.86667 2.58044 5.86667 3.06667V3.43333ZM5.13333 3.43333H3.09027C2.59893 3.43333 2.2 3.0344 2.2 2.54307V2.33333C2.2 2.0416 2.31589 1.76181 2.52218 1.55552C2.72847 1.34923 3.00826 1.23333 3.3 1.23333C3.54076 1.23333 3.77916 1.28075 4.00159 1.37289C4.22402 1.46502 4.42612 1.60006 4.59636 1.7703C4.7666 1.94055 4.90165 2.14265 4.99378 2.36508C5.08591 2.58751 5.13333 2.82591 5.13333 3.06667V3.43333Z",
    fill: "#010048",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M5.1334 7.09961H0.733398V9.66628C0.733398 10.1525 0.926553 10.6188 1.27037 10.9626C1.61419 11.3065 2.0805 11.4996 2.56673 11.4996H5.1334V7.09961ZM5.86673 11.4996H8.4334C8.91963 11.4996 9.38594 11.3065 9.72976 10.9626C10.0736 10.6188 10.2667 10.1525 10.2667 9.66628V7.09961H5.86673V11.4996Z",
    fill: "#010048",
    fillOpacity: 0.7
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1860_3742"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 11,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeenyiconsGiftSolid);
export default __webpack_public_path__ + "static/media/teenyicons_gift-solid.5ccc680a673d13d59478114267d7b119.svg";
export { ForwardRef as ReactComponent };